export const wsUrl = "wss://open-ws-swap.bingbon.pro/ws";
export const wsUrlV2 = "wss://open-api-swap.bingx.com/swap-market";
